import { Routes, Route, Navigate } from 'react-router-dom'
import { useUIStore } from '@/stores/useUIStore'
import HomePage from '@/pages/HomePage'
import TasksPage from '@/pages/TasksPage'
import ContactsPage from '@/pages/ContactsPage'
import ValidatorPage from '@/pages/ValidatorPage'
import WalletPage from '@/pages/WalletPage'
import BotCreatePage from '@/pages/BotCreatePage'
import ArtifactsPage from '@/pages/ArtifactsPage'
import MessagesPage from '@/pages/MessagesPage'
import SkillsPage from '@/pages/SkillsPage'
import ProfilePage from '@/pages/ProfilePage'
import SettingsPage from '@/pages/SettingsPage'
import NotFoundPage from '@/pages/NotFoundPage'

export default function App() {
  const { theme } = useUIStore()

  return (
    <div className={theme === 'dark' ? 'dark' : ''}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/validator" element={<ValidatorPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/bot/create" element={<BotCreatePage />} />
        <Route path="/artifacts" element={<ArtifactsPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/messages/:threadId" element={<MessagesPage />} />
        <Route path="/skills" element={<SkillsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  )
}
